import CloseIcon from "@assets/svg/CloseIcon";
// @ts-ignore
import ProfileImg from "@assets/profilePic1.png";
// @ts-ignore
import HiringCompanyImg from "@assets/images/hiringCompany.png";

import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogTitle,
} from "@components/ui/dialog";
import { Dispatch, SetStateAction } from "react";
import EmailInvite from "@assets/svg/EmailInvite";
import EmailOpenIconFilled from "@assets/svg/EmailOpenIconFilled";
import { useNavigate } from "react-router-dom";

interface CandidateSentSuccessModalProps {
  openModal: boolean;
  setOpenModal: Dispatch<SetStateAction<boolean>>;
  jobId:string
}

const CandidateSentSuccessModal = ({
  openModal,
  setOpenModal,
  jobId
}: CandidateSentSuccessModalProps) => {
  const navigate = useNavigate();
  return (
    <Dialog open={openModal} onOpenChange={setOpenModal}>
      <DialogContent showCloseButton={false} className="bg-white !max-w-xl">
        <DialogClose asChild>
          <button
            onClick={() => {
              setOpenModal(false);
            }}
            className="h-max ml-auto rounded-md hover:bg-gray-50 absolute right-3 top-3"
          >
            <CloseIcon className={"w-5 h-5"} />
          </button>
        </DialogClose>
        <div className="flex flex-col justify-center items-center pt-2 gap-10">
          <DialogTitle className="flex flex-col items-center gap-2 px-5">
            <EmailOpenIconFilled className={"h-20 w-20"} fill="#FF9800" />
            <span className="font-bold text-xl">
              Candidate Sent Successfully
            </span>
            <span className="text-xs font-medium text-light-black text-center">
              The candidate’s profile has been successfully sent to the hiring
              company for review.
            </span>
          </DialogTitle>

          {/* Detail box */}
          <div className="flex items-center rounded-md bg-gray-100 w-full p-5 gap-8">
            {/* Applicant Details */}
            <div className="flex flex-col gap-3 flex-1">
              <span className="font-semibold text-xs text-light-black">
                Applicant's Details
              </span>
              <div className="flex items-center gap-2.5">
                <img
                  src={HiringCompanyImg}
                  className="w-[48px] h-[48px] rounded-full flex-shrink-0"
                />

                <div className="flex flex-col gap-0.5">
                  <span className="font-semibold text-xs text-charcoal">
                    ABC Solutions Pvt. Ltd.
                  </span>
                  <span className="font-normal text-xs text-charcoal">
                    abc_solutions@yahoo.com
                  </span>
                </div>
              </div>
            </div>
            {/* Hiring company  */}
            <div className="flex flex-col gap-3 flex-1">
              <span className="font-semibold text-xs text-light-black">
                Hiring Company Details
              </span>
              <div className="flex items-center gap-2.5">
                <img
                  src={HiringCompanyImg}
                  className="w-[48px] h-[48px] rounded-full flex-shrink-0"
                />

                <div className="flex flex-col gap-0.5">
                  <span className="font-semibold text-xs text-charcoal">
                    ABC Solutions Pvt. Ltd.
                  </span>
                  <span className="font-normal text-xs text-charcoal">
                    abc_solutions@yahoo.com
                  </span>
                </div>
              </div>
            </div>
          </div>

          <DialogFooter className="w-full px-2">
            <button
              onClick={() => {
                setOpenModal(false);
                navigate("/");
              }}
              className="text-xs font-semibold text-charcoal bg-gray-200 rounded-md h-9 flex-1 hover:bg-gray-300"
            >
              Back to dashboard
            </button>
            <button
              onClick={() => {
                setOpenModal(false)
                navigate(`/job/${jobId}/application-management`)
              }}
              className="text-xs font-semibold text-white bg-primary rounded-md h-9 flex-1 hover:bg-black"
            >
              Back to applicants list
            </button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CandidateSentSuccessModal;
